import React, { type FC } from 'react';
import SectionTabs from '../section-tabs';
import {
  type ContactForm,
  useGetAllContactForms
} from '../../hooks/use-contact-form-data';
import { lowerCaseHyphen } from '../../utils/utils';
import { ContactRootPageProps } from './contact-root-page';

type ContactContentProps = Pick<
  ContactRootPageProps,
  'discoveryMeetingTitle' | 'discoveryMeetingText' | 'discoveryMeetings'
>;

export const ContactContent: FC<ContactContentProps> = (props) => {
  const { discoveryMeetingTitle, discoveryMeetingText, discoveryMeetings } =
    props;
  const forms = useGetAllContactForms();

  const tabs = [
    getContactFormProps(forms, 'startProject'),
    getContactFormProps(forms, 'general'),
    getContactFormProps(forms, 'siteSupport'),
    discoveryMeetingTitle &&
      discoveryMeetings?.length !== 0 && {
        name: discoveryMeetingTitle,
        searchId: lowerCaseHyphen(discoveryMeetingTitle),
        content: [
          {
            id: 'discovery-meeting',
            type: 'hubSpotCalendar',
            altStyling: true,
            text: discoveryMeetingText,
            meetings: discoveryMeetings
          }
        ]
      }
  ].filter((v) => !!v);

  return (
    <SectionTabs
      items={tabs}
      theme="dark"
      searchParamProp="form"
      dismountContent
    />
  );
};

const getContactFormProps = (forms: ContactForm[], id: string) => {
  const form = forms.find((form) => form.id === id);

  if (!form) return;

  return {
    name: form.title,
    searchId: lowerCaseHyphen(form.title),
    content: [
      {
        type: 'hubSpotForm',
        altStyling: true,
        ...form
      }
    ]
  };
};
